export function cleanString(string) {
  if (!string) return "";
  return string
    .trim()
    .toUpperCase()
    .replaceAll("Á", "A")
    .replaceAll("É", "E")
    .replaceAll("Í", "I")
    .replaceAll("Ó", "O")
    .replaceAll("Ú", "U");
}
